import styled, { css } from 'styled-components'

export const DisclosureContainer = styled.div`
  width: 100%;
`

export const SummaryContent = styled.div<{
  $summaryLines: number
  $expanded: boolean
}>`
  overflow: hidden;
  transition: max-height 0.2s ease-out;

  ${({ $expanded, $summaryLines }) =>
    !$expanded &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: ${$summaryLines};
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`

export const DetailContent = styled.div<{
  $expanded: boolean
  $animationDuration: number
}>`
  overflow: hidden;
  transition:
    max-height ${({ $animationDuration }) => $animationDuration}ms ease-out,
    opacity ${({ $animationDuration }) => $animationDuration}ms ease-out;
  max-height: ${({ $expanded }) => ($expanded ? '2000px' : '0')};
  opacity: ${({ $expanded }) => ($expanded ? 1 : 0)};
`

export const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  margin-top: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.medium};
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: all ${({ theme }) => theme.transitions.default};

  /* Ensure 44px minimum touch target on mobile */
  min-height: ${({ theme }) => theme.touchTargets.minimum};

  &:hover {
    background: ${({ theme }) => theme.colors.primaryLight};
  }

  &:focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover {
      background: none;
    }

    &:active {
      background: ${({ theme }) => theme.colors.primaryLight};
    }
  }

  svg {
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
  }
`
